export const Tabs = () => {
	const TabsInstances = document.querySelectorAll('.c-tabs');

	if (!TabsInstances.length) return;

	TabsInstances.forEach(instance => {
		// Setup our elements
		const triggers = instance.querySelectorAll('.js-tab-trigger');
		const slides = instance.querySelectorAll('.js-tab-item');
		const slideWrapper = instance.querySelector('.js-tab-items-wrapper');
		let animating = false;
		
		// Ensure we have out triggers and slides
		if (triggers.length && slides.length && slideWrapper) {
			// Create out click event on the triggers
			triggers.forEach(newTrigger => {
				newTrigger.addEventListener('click', () => {
					if (newTrigger.classList.contains('isActive') || animating) return;

					animating = true;

					// Get our new ID
					let id = newTrigger.dataset.id;
					
					// Set the current and new slides
					let currentTrigger = instance.querySelector(`.js-tab-trigger.isActive`);
					let currentSlide = instance.querySelector(`.js-tab-item.isActive`);
					let newSlide = instance.querySelector(`.js-tab-item[data-id="${id}"]`);

					// Set our new active key
					currentTrigger.classList.remove('isActive');

					// Add a timeout to create a little more visual impact
					setTimeout(() => {
						newTrigger.classList.add('isActive');
						instance.classList.add('isAnimating');
					}, 250);


					// Animate slide
					currentSlide.style.opacity = 0;
					slideWrapper.style.height = slideWrapper.offsetHeight + 'px';

					newSlide.style.display = 'block';
					newSlide.style.top = '50px';
					let newHeight = newSlide.offsetHeight + 'px';

					setTimeout(() => {
						newSlide.classList.add('u-cover');
					}, 0);
					
					setTimeout(() => {
						newSlide.style.opacity = 1;
						newSlide.style.top = 0;
						slideWrapper.style.height = newHeight;
					}, 250);

					setTimeout(() => {
						newSlide.classList.add('isActive');
						currentSlide.classList.remove('isActive');
						currentSlide.style.display = 'none';
					}, 500);

					setTimeout(() => {
						animating = false;
						newSlide.classList.remove('u-cover');
						slideWrapper.style.height = 'auto';
						instance.classList.remove('isAnimating');
					}, 750)
				});
			});
		}
	});
}